import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { useThemes } from "../Theme/theme";
import { showSuccessSnackbar } from "../snackBar/snakbar";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px"
};

const DeleteNonItems = ({ open, setOpen, entryInd, entryRows, setEntryRows,setDeletedRows }) => {
    const { theme } = useThemes()

    const [loading, setLoading] = useState(false);
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }

    const deleteItem = () => {
        setLoading(true)

        let arr = [];
        setLoading(true);
        Math.floor(new Date().getTime() / 1000);
        const exp = Math.floor(new Date().getTime() / 1000);
        arr = [...entryRows].filter((item, ind) => {
          if (ind != entryInd) {
            return item;
          }
        });
        let deletedArr=[...entryRows]?.filter((item,ind )=> ind === entryInd);
        deletedArr = deletedArr.map((item, ind) => {
          return { ...item, expiredtimestamp: exp };
        });
        
        
        setDeletedRows(prevDeletedRows => [...prevDeletedRows, ...deletedArr]);
        setEntryRows(arr)
        setOpen(false)
        setLoading(false)
        showSuccessSnackbar('Entry Deleted');
    }

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            <Box sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>

                    <Typography sx={{ color: theme?.palette?.TmId.id.toString().includes("9") ? "#FFF1E6" : "rgb(60 60 60)", fontWeight: "bold" }}>
                        Do you want to delete this item?
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // flexDirection: { xs: 'column', sm: 'row' },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    <Button disabled={loading} onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                    {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
                    <LoadingButton color="error" sx={{ flex: 1, margin: '5px', fontSize: "12px" }} loading={loading} disableRipple={true} variant="contained" onClick={() => deleteItem()}>
                        Yes
                    </LoadingButton>
                </Box>


            </Box>
            {/* </Fade> */}
        </Modal>

    );
};

export default DeleteNonItems;